import { render, staticRenderFns } from "./userMy_orderInfoAttr.vue?vue&type=template&id=6e7a2f04&scoped=true"
import script from "./userMy_orderInfoAttr.vue?vue&type=script&lang=js"
export * from "./userMy_orderInfoAttr.vue?vue&type=script&lang=js"
import style0 from "./userMy_orderInfoAttr.vue?vue&type=style&index=0&id=6e7a2f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7a2f04",
  null
  
)

component.options.__file = "userMy_orderInfoAttr.vue"
export default component.exports